import React, { useState, useEffect, useRef } from "react";
import { hermesStatusApi } from "../lib/api";
import { Lightning } from "@phosphor-icons/react";

export default function HermesStatusBadge() {
  const [status, setStatus]   = useState(null); // null=loading, {active,current}
  const [visible, setVisible] = useState(false);
  const pollRef = useRef(null);

  const poll = async () => {
    try {
      const { data } = await hermesStatusApi.get();
      setStatus(data);
    } catch {
      // silently ignore — badge just shows last known state
    }
  };

  useEffect(() => {
    poll();
    // Poll every 10s when idle, every 4s when active
    const schedule = () => {
      const interval = status?.active ? 4000 : 10000;
      pollRef.current = setTimeout(async () => {
        await poll();
        schedule();
      }, interval);
    };
    schedule();
    return () => clearTimeout(pollRef.current);
  }, [status?.active]); // re-schedule when active state changes

  if (status === null) return null;

  const isActive = status.active;
  const label    = status.current;

  return (
    <div
      className="fixed bottom-4 right-4 z-50"
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {/* Tooltip */}
      {visible && label && (
        <div className="absolute bottom-full right-0 mb-2 w-64 bg-slate-900 text-white text-[12px] rounded-lg px-3 py-2 shadow-lg leading-relaxed">
          <div className="text-[10px] font-semibold uppercase tracking-widest text-slate-400 mb-1">
            Hermes is working on
          </div>
          <div className="text-slate-200">{label}</div>
          <div className="absolute bottom-0 right-4 translate-y-1/2 w-2 h-2 bg-slate-900 rotate-45" />
        </div>
      )}

      {/* Badge pill */}
      <div className={`flex items-center gap-2 rounded-full px-3 py-1.5 shadow-md border transition-all duration-300 cursor-default select-none ${
        isActive
          ? "bg-white border-emerald-200 shadow-emerald-100"
          : "bg-white border-slate-200"
      }`}>
        {/* Status dot */}
        <span className="relative flex items-center justify-center">
          <span className={`w-2 h-2 rounded-full ${isActive ? "bg-emerald-500" : "bg-slate-300"}`} />
          {isActive && (
            <span className="absolute w-2 h-2 rounded-full bg-emerald-400 animate-ping opacity-75" />
          )}
        </span>

        <Lightning
          size={11}
          weight="fill"
          className={isActive ? "text-emerald-600" : "text-slate-400"}
        />

        <span className={`text-[11px] font-semibold leading-none ${
          isActive ? "text-emerald-700" : "text-slate-400"
        }`}>
          {isActive ? "Hermes active" : "Hermes idle"}
        </span>
      </div>
    </div>
  );
}
